import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"background-color":"var(--color-white)","padding":"20px","margin-bottom":"40px","border-radius":"4px"} }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-5" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-4 mb-2" }
const _hoisted_6 = {
  class: "signature-line-city",
  style: {"font-size":"14px","line-height":"1.2","padding-bottom":"30px","position":"relative"}
}
const _hoisted_7 = { style: {"position":"absolute","bottom":"0px","left":"0","font-size":"14px","z-index":"1"} }
const _hoisted_8 = { class: "col-8 mb-2" }
const _hoisted_9 = {
  class: "signature-line-corporation",
  style: {"font-size":"14px","white-space":"nowrap","width":"100%"}
}
const _hoisted_10 = { class: "col-5" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-6 mb-2" }
const _hoisted_13 = {
  class: "signature-line",
  style: {"font-size":"14px"}
}
const _hoisted_14 = { class: "col-6 mb-2" }
const _hoisted_15 = {
  class: "signature-line",
  style: {"font-size":"14px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createTextVNode(_toDisplayString(_ctx.$t(
                  `project.previewAndReport.reportTypes.${_ctx.reportType}.signature.city`
                )) + " ", 1),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.currentDate), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t(
                  `project.previewAndReport.reportTypes.${_ctx.reportType}.signature.corporation`
                )), 1)
          ])
        ])
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-2" }, null, -1)),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t(
                  `project.previewAndReport.reportTypes.${_ctx.reportType}.signature.date`
                )), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t(
                  `project.previewAndReport.reportTypes.${_ctx.reportType}.signature.signature`
                )), 1)
          ])
        ])
      ])
    ])
  ]))
}